import React from 'react';

import styles from './TimeDisplay.module.scss';

export type TimeDisplayProps = {
  currentTime: number;
  startTime: number;
  endTime: number;
};

const formatTime = (timeInSeconds: number): string => {
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds % 3600) / 60);
  const seconds = Math.floor(timeInSeconds % 60);

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }
  return `${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}`;
};

export const TimeDisplay: React.FC<TimeDisplayProps> = ({
  currentTime,
  startTime,
  endTime,
}) => {
  const duration = endTime - startTime;
  const relativeCurrentTime = Math.max(0, currentTime - startTime);

  return (
    <div className={styles.timeDisplay}>
      <span>{formatTime(relativeCurrentTime)}</span>
      <span>/</span>
      <span>{formatTime(duration)}</span>
    </div>
  );
};
